// extracted by mini-css-extract-plugin
export default {"image":"JackpotLogo_image__gFbqb"};